/**
 *  Set toggle functionality for category level 1
 *
 */
const init = () => {
    document.querySelectorAll(".sitemap-link--level-3.expandable .sitemap--arrow").forEach($arrow => {
        $arrow.addEventListener("click", e => {
            const $target = e.currentTarget;

            $target.classList.toggle("active");
            $target.closest(".sitemap-wrapper--level-3").querySelector(".sitemap-list--level-4").classList.toggle("d-none");
        });
    });
};

export { init };
